/**
 * App
 *
 * Polyfills
 * Plugins
 * Utils
 * Global modules
 * Global JS
 * App init
 */

/**
 * Polyfills
 */
import '../lib/polyfills';

/**
 * Plugins
 */
import 'regenerator-runtime/runtime';
import 'what-input';
import '../lib/lazy-load-option';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/attrchange/ls.attrchange';

/**
 * Utils
 */
import '../util/add-class';
import '../util/ajax';
import '../util/array-to-lower';
import '../util/click-outside';
import '../util/debounce';
import '../util/expand';
import '../util/extend';
import '../util/encode';
import '../util/events';
import '../util/focus-first-input';
import '../util/format-price';
import '../util/format-price-display';
import '../util/format-price-number';
import '../util/get-hidden-styles';
import '../util/get-image-sizes';
import '../util/get-query-string';
import '../util/get-sized-image-url';
import '../util/get-url-parameter';
import '../util/handleize';
import '../util/has-class';
import '../util/hide';
import '../util/insert-after';
import '../util/is-delimited-array';
import '../util/is-dom-element';
import '../util/is-object';
import '../util/is-object-empty';
import '../util/media-query';
import '../util/namespace';
import '../util/number-with-commas';
import '../util/object-to-query-string';
import '../util/parents';
import '../util/remap-size-values';
import '../util/remove-class';
import '../util/remove-class-by-prefix';
import '../util/remove-protocol';
import '../util/scroll-to';
import '../util/serialize';
import '../util/set-hash';
import '../util/show';
import '../util/slide';
import '../util/to-number';
import '../util/transition';
import '../util/trigger';
import '../util/typewriter';
import '../util/upcase';
import '../util/waypoint';
import '../util/window-resize';
import '../util/load-jsonp';
import '../util/ready';

/**
 * Global modules
 */
import '../lib/accordion';
import '../lib/bag-config';
import '../lib/bag-count';
import '../lib/bag-empty';
import '../lib/bag-init';
import '../lib/bag-items';
import '../lib/bag-recalc';
import '../lib/bag-refresh';
import '../lib/bag-update';
import '../lib/bag-upsell';
import '../lib/bag-variant';
import '../lib/carousel';
import '../lib/cookies';
import '../lib/countdown-timer';
import '../lib/hide-header-footer';
import '../lib/incrementer';
import '../lib/input-placeholder';
import '../lib/messages';
import '../lib/modal-clear';
import '../lib/modal-get-html';
import '../lib/modal';
import '../lib/newsletter';
import '../lib/quickview';
import '../lib/tabs';
import '../lib/toggle-dropdown';
import '../lib/video';
import '../lib/video-embed';
import '../lib/user-market-by-geo';
import globalUploadApp from '../lib/globalUploadApp';

/**
 * App init
 */
import '../lib/app-init';

globalUploadApp();